import Dexie, { type Table } from 'dexie';
import type {
  FileThumbnailBlobEntry,
  UploadQueueBlobEntry,
  UploadQueueItemEntry,
  UploadSessionEntry,
} from './schema';
import {
  FILE_THUMBNAILS_STORE_SCHEMA,
  UPLOAD_QUEUE_BLOBS_STORE_SCHEMA,
  UPLOAD_QUEUE_ITEMS_STORE_SCHEMA,
  UPLOAD_SESSIONS_STORE_SCHEMA,
} from './schema';

/**
 * DB name using reverse-domain convention (e.g. enterprise.filegrant.net → filegrant.net.filegrant.enterprise).
 * Isolates IndexedDB per hostname for multi-tenant deployments.
 */
function getDbName(): string {
  if (typeof window === 'undefined') return 'Filegrant';
  const hostname = window.location.hostname;
  const parts = hostname.split('.').filter(Boolean);
  const reversed = parts.length > 0 ? parts.reverse().join('.') : 'default';
  return `filegrant.${reversed}`;
}

export interface FilegrantAppDB extends Dexie {
  fileThumbnails: Table<FileThumbnailBlobEntry, number>;
  uploadSessions: Table<UploadSessionEntry, string>;
  uploadQueueItems: Table<UploadQueueItemEntry, string>;
  uploadQueueBlobs: Table<UploadQueueBlobEntry, string>;
}

/**
 * Dexie database instance.
 * Tables and versioning are defined here; add new stores in schema.ts and bump version when needed.
 */
export const db = new Dexie(getDbName()) as FilegrantAppDB;

db.version(1).stores({
  fileThumbnails: FILE_THUMBNAILS_STORE_SCHEMA,
});

db.version(2).stores({
  fileThumbnails: FILE_THUMBNAILS_STORE_SCHEMA,
  uploadSessions: UPLOAD_SESSIONS_STORE_SCHEMA,
  uploadQueueItems: UPLOAD_QUEUE_ITEMS_STORE_SCHEMA,
  uploadQueueBlobs: UPLOAD_QUEUE_BLOBS_STORE_SCHEMA,
});
